import React, { Component } from 'react';
import { connect } from 'react-redux';
import './slick.scss';
import { withRouter } from 'react-router-dom';
import { Carousel } from 'element-react';
import 'element-theme-default'; // 引入 element 主题
import CommonTitle from '../common-title/index';

class SlickComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cardDesc: '中日先进医疗与新药研发高峰论坛暨成成果大会',
      titleList: [],
      idList: [],
      selectedId: []
    }

  }

  handleSlickChange(e) {
    const { titleList, idList } = this.state;
    this.setState({
      cardDesc: titleList[e],
      selectedId: idList[e]
    });
  }

  handleClickTitle(e) {
    const id = e.currentTarget.dataset.id;
    const name = this.state.cardDesc;
    // console.log('id', id);
    this.props.history.push({
      pathname: '/case/' + id, state: {
        type: 'achieve',
        id: id,
        title: name
      }
    });
  }

  render() {

    const { cases } = this.props;
    const { cardDesc, titleList, idList, selectedId } = this.state;

    return (
      <div className="slick-content">
        <div className="slick-content__wrap">
          <CommonTitle title="成功案例"></CommonTitle>
          <Carousel
            autoplay={false}
            arrow="hover"
            type="card"
            indicatorPosition="none"
            // height="390px"
            ref="carousel"
            onChange={(index) => this.handleSlickChange(index)}
          >
            {
              cases.map((item) => {
                titleList.push(item.get('name'));
                idList.push(item.get('id'));
                return (
                  <Carousel.Item key={item.get('id')} name={item.get('name')} className="b_img">
                    <img className="slick-content__main-pic" src={item.get('logo')} alt=""></img>
                  </Carousel.Item>
                )
              })
            }
          </Carousel>
          <p className="slick-content__desc" data-id={ selectedId } onClick={this.handleClickTitle.bind(this)}>{ cardDesc }</p>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  cases: state.getIn(['home', 'cases'])
});

export default withRouter(connect(mapState, null)(SlickComponent));
